const STORAGE_KEY = 'service-recommender';
export const loadState = () => {
	try {
		const serializedState = sessionStorage.getItem( STORAGE_KEY );
		if ( serializedState === null ){
			return undefined;
		}
		return JSON.parse(serializedState);
	} catch (err) {
		return undefined;
	}
};

export const clearState = () => {
	sessionStorage.removeItem( STORAGE_KEY );
}
export const saveState = (state) => {
	try {
		const serializedState = JSON.stringify(state);
		sessionStorage.setItem(STORAGE_KEY, serializedState);
	} catch (err) {
		// ignore
	}
}